<article
  class="ui-indicator-card"
  [class.ui-indicator-card--increase]="increasing()"
  [class.ui-indicator-card--decrease]="!increasing()"
  [class.ui-indicator-card--interactive]="interactive()"
  [attr.role]="interactive() ? 'button' : null"
  [attr.tabindex]="interactive() ? 0 : null"
  (click)="onCardClick($event)"
  (keydown.enter)="onCardKeydown($event)"
  (keydown.space)="onCardKeydown($event)"
>
  <header class="ui-indicator-card__header">
    <h3 class="ui-indicator-card__title">{{ title() }}</h3>
    @if (showMore()) {
      <ui-button variant="ghost" size="sm" (pressed)="moreClick.emit($event)">
        {{ moreLabel() }}
      </ui-button>
    }
  </header>

  <div class="ui-indicator-card__divider" aria-hidden="true"></div>

  <div
    class="ui-indicator-card__body"
    [class.ui-indicator-card__body--summary-only]="!showChart()"
  >
    <div class="ui-indicator-card__summary">
      <p class="ui-indicator-card__amount">{{ amount() }}</p>
      <p class="ui-indicator-card__variation">
        <svg
          class="ui-indicator-card__trend-icon"
          viewBox="0 0 16 16"
          aria-hidden="true"
          focusable="false"
        >
          @if (increasing()) {
            <path d="M8 13V3m0 0L4 7m4-4 4 4" />
          } @else {
            <path d="M8 3v10m0 0 4-4m-4 4L4 9" />
          }
        </svg>
        <span>{{ variationValue() }}</span>
        <span class="ui-indicator-card__variation-period">
          {{ variationPeriodLabel() }}
        </span>
      </p>
    </div>

    @if (showChart()) {
      <div
        class="ui-indicator-card__chart"
        role="img"
        [attr.aria-label]="chartLabel()"
      >
        @for (bar of bars(); track bar.label; let index = $index) {
          <div
            class="ui-indicator-card__period"
            [class.ui-indicator-card__period--first]="index === 0"
            [class.ui-indicator-card__period--last]="
              index === bars().length - 1
            "
            (mouseenter)="hoveredIndex.set(index)"
            (mouseleave)="hoveredIndex.set(null)"
          >
            <div class="ui-indicator-card__bar-track">
              <span
                class="ui-indicator-card__bar"
                [class.ui-indicator-card__bar--current]="bar.current"
                [class.ui-indicator-card__bar--hovered]="
                  hoveredIndex() === index
                "
                [class.ui-indicator-card__bar--dimmed]="
                  hoveredIndex() !== null && hoveredIndex() !== index
                "
                [style.height.%]="bar.height"
              ></span>
            </div>
            <span class="ui-indicator-card__period-label">
              {{ bar.label }}
            </span>

            @if (hoveredIndex() === index) {
              <span
                class="ui-indicator-card__tooltip"
                aria-hidden="true"
              >
                <strong class="ui-indicator-card__tooltip-value">
                  {{ bar.valueLabel || bar.value }}
                </strong>
              </span>
            }
          </div>
        }
      </div>
    }
  </div>
</article>
